// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"fdc3aff9","942":"5e334023"}[chunkId] + ".css";
};